
export default ({ label }: { label: string }) => (label ?
  <div className='bg-gray-100 text-grey-800 flex justify-center max-w-max rounded-xl py-0.5 px-3 text-xs leading-4'>{label.toUpperCase()}</div> : null
);
